module.exports = __webpack_public_path__ + "media/images/emblems/Beinwil_SO-blason-dd2a50ed3235c2fa7f7d8833870e597e.png";